import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import CheckboxSection from "@Shared/components/sections/checkbox-section.vue";
import { defineComponent, ref, onMounted, computed } from "@vue/composition-api";
import { useAccountStoreActions, useAccountStoreMutations, useAccountStoreGetters } from "@Client/@Modules/main/store/account/account-helpers";
import * as AccountGetters from "@Client/@Modules/main/store/account/account-getters";
import * as AccountActions from "@Client/@Modules/main/store/account/account-actions";
import * as AccountMutations from "@Client/@Modules/main/store/account/account-mutations";
import { useDeprecatedApplicationStoreActions } from "@Client/@Modules/deprecated-application/store/application-helpers";
import * as ApplicationActions from "@Client/@Modules/deprecated-application/store/application-actions";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { fullName } from "@Shared/@Utils/helpers/text";
export default defineComponent({
  name: "NewAppModal",
  components: {
    GenericModal,
    SimpleButton,
    CheckboxSection
  },
  mixins: [validationMixin],
  validations: {
    selectedOption: {
      required
    }
  },
  setup(_, {
    emit
  }) {
    const modalOpened = ref(false);
    const addNewAppModal = ref(null);
    const page = ref("select");
    const selectedOption = ref(0);
    const selectedBroker = ref("");
    const selectedBrokerage = ref("");
    const confirm = ref(false);
    const accountAgents = ref();
    const brokerageId = ref(0);
    const subdomain = ref("");
    const loading = ref(false);
    const {
      LOAD_ACCOUNT_AGENTS
    } = useAccountStoreActions([AccountActions.LOAD_ACCOUNT_AGENTS]);
    const {
      LOAD_RAW_APPLICATION,
      CREATE_NEW_APPLICATION
    } = useDeprecatedApplicationStoreActions([ApplicationActions.LOAD_RAW_APPLICATION, ApplicationActions.CREATE_NEW_APPLICATION]);
    const {
      GET_ACCOUNT_AGENTS
    } = useAccountStoreGetters([AccountGetters.GET_ACCOUNT_AGENTS]);
    const {
      SET_SELECTED_APPLICATION_ID,
      SET_ACCOUNT_SUBDOMAIN,
      SET_BROKERAGE_SUBDOMAIN
    } = useAccountStoreMutations([AccountMutations.SET_SELECTED_APPLICATION_ID, AccountMutations.SET_ACCOUNT_SUBDOMAIN, AccountMutations.SET_BROKERAGE_SUBDOMAIN]);
    onMounted(async () => {
      await LOAD_ACCOUNT_AGENTS();
      const agents = JSON.parse(_JSON$stringify(GET_ACCOUNT_AGENTS.value)).agents;
      accountAgents.value = _filterInstanceProperty(agents).call(agents, (agent, index) => index === _findIndexInstanceProperty(agents).call(agents, a => a.username === agent.username));
    });
    const openModal = () => {
      [selectedBroker.value, selectedBrokerage.value] = getAgentAndBrokerage(0);
      brokerageId.value = accountAgents.value[0].brokerage_id;
      subdomain.value = accountAgents.value[0].subdomain;
      modalOpened.value = true;
      addNewAppModal.value.show();
    };
    const closeModal = () => {
      if (modalOpened.value) {
        addNewAppModal.value.hide();
      }
    };
    const options = computed(() => {
      var _context;
      return _mapInstanceProperty(_context = accountAgents.value).call(_context, (el, index) => {
        const agentFullName = fullName(el) + " - " + el.brokerage_name;
        return {
          value: index,
          text: agentFullName
        };
      });
    });
    const getAgentAndBrokerage = selectedOption => {
      return options.value[selectedOption].text.split("-");
    };
    const resetModal = () => {
      [selectedBroker.value, selectedBrokerage.value] = getAgentAndBrokerage(0);
      selectedOption.value = 0;
      confirm.value = false;
      page.value = "select";
      confirm.value = false;
    };
    const handleChangeOption = selectedOption => {
      [selectedBroker.value, selectedBrokerage.value] = getAgentAndBrokerage(selectedOption);
      brokerageId.value = accountAgents.value[selectedOption].brokerage_id;
      subdomain.value = accountAgents.value[selectedOption].subdomain;
    };
    const handleCreateApplication = async () => {
      loading.value = true;
      const applicationId = await CREATE_NEW_APPLICATION({
        currentSubdomain: subdomain.value,
        brokerageId: brokerageId.value,
        fromClient: true
      });
      SET_BROKERAGE_SUBDOMAIN({
        brokerageId: brokerageId.value
      });
      await SET_SELECTED_APPLICATION_ID(applicationId);
      await SET_ACCOUNT_SUBDOMAIN({
        subdomain: subdomain.value
      });
      await LOAD_RAW_APPLICATION(applicationId);
      location.replace(`/${subdomain.value}#/application?nt=true`);
      emit("refresh");
      loading.value = false;
      addNewAppModal.value.hide();
    };
    return {
      options,
      accountAgents,
      modalOpened,
      addNewAppModal,
      confirm,
      page,
      selectedBroker,
      selectedBrokerage,
      selectedOption,
      brokerageId,
      subdomain,
      loading,
      getAgentAndBrokerage,
      handleChangeOption,
      openModal,
      closeModal,
      resetModal,
      handleCreateApplication
    };
  }
});